import * as React from "react";

import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import {
  policyKindLabel,
  type PolicyKind,
} from "@/utils/policyKindChips";

/** Quiet outline chips — match workspace/report symbol chrome. */
export const POLICY_KIND_CHIP_CLASS =
  "h-5 border-border/80 bg-transparent px-1.5 font-[family-name:var(--font-primary)] text-[10px] font-medium normal-case tracking-normal text-muted-foreground shadow-none dark:border-sidebar-muted-foreground/50 dark:text-sidebar-muted-foreground";

export type PolicyKindChipsProps = {
  kinds: PolicyKind[];
  className?: string;
  chipClassName?: string;
  /** Accessible name for the chip group. */
  "aria-label"?: string;
};

/** Subtle Keep · Remove · SL · TP chips from BE `policy_kinds`. */
export function PolicyKindChips({
  kinds,
  className,
  chipClassName,
  "aria-label": ariaLabel = "Policy kinds",
}: PolicyKindChipsProps): React.ReactElement | null {
  if (kinds.length === 0) return null;

  return (
    <div
      data-policy-kind-chips=""
      className={cn("flex min-w-0 flex-wrap items-center gap-1", className)}
      aria-label={ariaLabel}
    >
      {kinds.map((kind) => (
        <Badge
          key={kind}
          variant="outline"
          data-policy-kind={kind}
          className={cn(POLICY_KIND_CHIP_CLASS, chipClassName)}
        >
          {policyKindLabel(kind)}
        </Badge>
      ))}
    </div>
  );
}
